import React from 'react';

import AITool from '@/3.0/ai-tools/entry';
import Layout from '@/components/layout';

const AIToolPage: React.FC & {
  getLayout?: (page: React.ReactElement) => React.ReactNode;
} = () => {
  return <AITool />;
};

AIToolPage.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;

export const getStaticProps = async () => {
  return {
    props: {},
  };
};

export default AIToolPage;
